var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOutlinedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4486 3.87525C13.8011 3.52286 13.9992 3.04489 13.9992 2.54648C13.9993 2.04807 13.8014 1.57005 13.449 1.21758C13.0966 0.865107 12.6186 0.667055 12.1202 0.666992C11.6218 0.66693 11.1438 0.864862 10.7913 1.21725L1.89397 10.1166C1.73918 10.2709 1.62471 10.4609 1.56064 10.6699L0.679972 13.5712C0.662742 13.6289 0.661441 13.6901 0.676206 13.7485C0.690971 13.8068 0.721252 13.8601 0.763836 13.9026C0.80642 13.9451 0.859719 13.9753 0.918078 13.99C0.976436 14.0046 1.03768 14.0032 1.09531 13.9859L3.99731 13.1059C4.20608 13.0424 4.39609 12.9286 4.55064 12.7746L13.4486 3.87525Z",
    stroke: "#4A5565",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlinedIcon);
export default __webpack_public_path__ + "static/media/edit-outlined-icon.ba5ce3a916abaf06119212780d1ef66d.svg";
export { ForwardRef as ReactComponent };